export default "/_next/static/chunks/fonts/Syne Talic-4edc3a127d733d797f19bc4a8de72ff5.otf";